import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthService } from './auth.service';
import { CoreService } from './core.service';
import { environment } from 'src/environments/environment';
const jwt = new JwtHelperService();
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class SecurityService {

  constructor(private authService: AuthService, private coreService: CoreService) { }

  hasClaim(type, value) {
    const decode = this.authService.getDecodedToken();
    if (type in decode || type == 'home') {
      if (type == 'home') {
        return true
      } else {
        const valueSearch = decode[type].indexOf(value);
        if (valueSearch < 0) {
          return false;
        } else {
          return true;
        }
      }

    } else {
      return false;
    }
  }

  letScriptData(dataToEncript): string {
    environment
    let key = CryptoJS.enc.Utf8.parse(environment.secretIV);
    let iv = CryptoJS.enc.Utf8.parse(environment.secretIV);

    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(dataToEncript), key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  }
}
